/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ImageShowResponse } from '../../models/image-show-response';

export interface DeleteImageRemove$Params {
  id: string;
}

export function deleteImageRemove(http: HttpClient, rootUrl: string, params: DeleteImageRemove$Params, context?: HttpContext): Observable<StrictHttpResponse<ImageShowResponse>> {
  const rb = new RequestBuilder(rootUrl, deleteImageRemove.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ImageShowResponse>;
    })
  );
}

deleteImageRemove.PATH = '/v1/image/{id}';
